import { Box, styled } from '@mui/material';

const TitleWrapper = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
});

export { TitleWrapper };
